import { APIcallerv2 } from '@services/APIcaller';

const getTargetIdAuditLogs = (targetId) => APIcallerv2.apiGet(`/audits/${targetId}`);

export default {
  getTargetIdAuditLogs,
};
